<template>
  <router-view />
</template>
<script>
export default {
  name: 'child-view-area'
}
</script>
<style>
  .children-wrapper{
    height: 100%;
    padding: 0 24px 16px;
    /* background: red; */
  }
</style>



// WEBPACK FOOTER //
// src/views/childViewArea.vue